<div class="flex flex-col gap-3 pb-4">
  <mat-divider />
  @for (stopTime of stopTimes; track stopTime) {
    <app-search-station-detailed-result-routes-calendar-list-item [stopTime]="stopTime" [lines]="lines" [routeSpecialMessages]="routeSpecialMessages" [stopCode]="stopCode" (pickLineEvent)="pickLineEvent.emit($event)" [isToday]="isToday" [selectedDate]="selectedDate" [selectedTime]="selectedTime"/>
    <mat-divider />
  }
</div>
